/**
 * Canonical day-of-week numbering for station clocks.
 *
 * `day_of_week` on the wire and in station_clocks is 0=Sunday … 6=Saturday, the
 * same as `Date.getDay()`. The backend mirror is layers/lockout/python/day_of_week.py.
 * Station rates (mon..sun flags) and ratings (MON..SUN) are keyed by name instead.
 */
export const DAY_OF_WEEK_OPTIONS: ReadonlyArray<{ value: number; label: string }> = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
]

/** day_of_week (0=Sunday) of a local calendar date. */
export function dayOfWeekOf(date: Date): number {
  return date.getDay()
}

/**
 * Parse an API day_of_week (0-6, "0"-"6", or a day name) to 0=Sunday … 6=Saturday.
 * Returns null for anything else.
 */
export function parseDayOfWeek(raw: unknown): number | null {
  if (raw === null || raw === undefined || raw === "") return null
  if (typeof raw === "number") {
    return Number.isInteger(raw) && raw >= 0 && raw <= 6 ? raw : null
  }
  const text = String(raw).trim()
  const byName = DAY_OF_WEEK_OPTIONS.find((d) => d.label.toLowerCase() === text.toLowerCase())
  if (byName) return byName.value
  if (!/^\d+$/.test(text)) return null
  const n = Number.parseInt(text, 10)
  return n >= 0 && n <= 6 ? n : null
}

export function dayOfWeekLabel(dayOfWeek: number): string {
  return DAY_OF_WEEK_OPTIONS.find((d) => d.value === dayOfWeek)?.label ?? `Day ${dayOfWeek}`
}
